function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import find from 'lodash/find';
import get from 'lodash/get';
import reject from 'lodash/reject';
import { registerAction, unregisterAction } from 'helpers/reducerTools';
import { SET_NEW_CONFIGURATION_VERSION } from 'modules/App/actionTypes';
import { SIGN_OUT_SUCCESS } from 'modules/Account/actionTypes';
import * as actionTypes from './actionTypes';
const initialState = {
    countryCode: null,
    paginationParams: null,
    organizationsCount: 0,
    organizations: [],
    organizationMemberships: [],
    organizationMembershipDetails: null,
    customIdentifiers: [],
    organizationTemplate: [],
    fetching: [],
    sending: [],
    errors: []
};
export default function reducer(state = _object_spread({}, initialState), action = {}) {
    switch(action.type){
        case actionTypes.FETCH_ORGANIZATIONS:
            {
                const { paginationParams } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    paginationParams,
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATIONS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATIONS)
                });
            }
        case actionTypes.FETCH_ORGANIZATIONS_SUCCESS:
            {
                const { organizations, organizationsCount } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizations,
                    organizationsCount,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATIONS)
                });
            }
        case actionTypes.FETCH_ORGANIZATIONS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    paginationParams: null,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATIONS),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATIONS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_SUCCESS:
            {
                const { organizationMemberships } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIPS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS:
            {
                const organizationMembershipDetails = null;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMembershipDetails,
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS_SUCCESS:
            {
                const { organizationMembershipDetails } = action.payload;
                return _object_spread_props(_object_spread({}, state), {
                    organizationMembershipDetails,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATION_MEMBERSHIP_DETAILS)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.FETCH_ORGANIZATION_TEMPLATE:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: registerAction(state.fetching, actionTypes.FETCH_ORGANIZATION_TEMPLATE),
                    errors: unregisterAction(state.errors, actionTypes.FETCH_ORGANIZATION_TEMPLATE)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_TEMPLATE_SUCCESS:
            {
                const { countryCode, organizationTemplate } = action.payload;
                if (countryCode === state.countryCode) {
                    return _object_spread_props(_object_spread({}, state), {
                        fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_TEMPLATE)
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    countryCode,
                    organizationTemplate,
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_TEMPLATE)
                });
            }
        case actionTypes.FETCH_ORGANIZATION_TEMPLATE_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    fetching: unregisterAction(state.fetching, actionTypes.FETCH_ORGANIZATION_TEMPLATE),
                    errors: registerAction(state.errors, actionTypes.FETCH_ORGANIZATION_TEMPLATE)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.CREATE_ORGANIZATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.CREATE_ORGANIZATION),
                    errors: unregisterAction(state.errors, actionTypes.CREATE_ORGANIZATION)
                });
            }
        case actionTypes.CREATE_ORGANIZATION_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CREATE_ORGANIZATION)
                });
            }
        case actionTypes.CREATE_ORGANIZATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.CREATE_ORGANIZATION),
                    errors: registerAction(state.errors, actionTypes.CREATE_ORGANIZATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.JOIN_ORGANIZATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.JOIN_ORGANIZATION),
                    errors: unregisterAction(state.errors, actionTypes.JOIN_ORGANIZATION)
                });
            }
        case actionTypes.JOIN_ORGANIZATION_SUCCESS:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.JOIN_ORGANIZATION)
                });
            }
        case actionTypes.JOIN_ORGANIZATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.JOIN_ORGANIZATION),
                    errors: registerAction(state.errors, actionTypes.JOIN_ORGANIZATION)
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case actionTypes.LEAVE_ORGANIZATION:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: registerAction(state.sending, actionTypes.LEAVE_ORGANIZATION),
                    errors: unregisterAction(state.errors, actionTypes.LEAVE_ORGANIZATION)
                });
            }
        case actionTypes.LEAVE_ORGANIZATION_SUCCESS:
            {
                const { organizationMembership } = action.payload;
                const { organizationUID } = organizationMembership;
                const organizationMemberships = reject(state.organizationMemberships, {
                    organizationUID
                });
                return _object_spread_props(_object_spread({}, state), {
                    organizationMemberships,
                    sending: unregisterAction(state.sending, actionTypes.LEAVE_ORGANIZATION)
                });
            }
        case actionTypes.LEAVE_ORGANIZATION_ERROR:
            {
                return _object_spread_props(_object_spread({}, state), {
                    sending: unregisterAction(state.sending, actionTypes.LEAVE_ORGANIZATION),
                    errors: registerAction(state.errors, actionTypes.LEAVE_ORGANIZATION)
                });
            }
        // BackOffice UPDATE -----------------------------------------------------------------------------------------------
        case SET_NEW_CONFIGURATION_VERSION:
            {
                const { organizationTemplateByCountryCode } = action.payload;
                if (!state.countryCode || !organizationTemplateByCountryCode) {
                    return _object_spread({}, state);
                }
                const organizationTemplateFields = find(organizationTemplateByCountryCode, (templateByCountryCode)=>templateByCountryCode.countryCode === state.countryCode) || {};
                const organizationTemplate = get(organizationTemplateFields, 'fieldDefinitions');
                if (!organizationTemplate) {
                    return _object_spread({}, state);
                }
                return _object_spread_props(_object_spread({}, state), {
                    organizationTemplate
                });
            }
        //------------------------------------------------------------------------------------------------------------------
        case SIGN_OUT_SUCCESS:
            {
                return _object_spread({}, initialState);
            }
        //------------------------------------------------------------------------------------------------------------------
        default:
            {
                return state;
            }
    }
}
